import { useLocation, useNavigate } from "@/lib/router";

const useAppNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateTo = (
    path: string,
    options: {
      preserveQuery?: boolean;
      noPreserveKey?: string[];
    } = {},
  ) => {
    const finalOptions = {
      preserveQuery: true,
      noPreserveKey: [],
      ...options,
    };

    let [basePath, pathQueryParams] = path.split("?");
    const mergedQueryParams = new URLSearchParams(pathQueryParams);

    // Remove keys in noPreserveKey from the path's query parameters
    finalOptions.noPreserveKey?.forEach((key) => {
      mergedQueryParams.delete(key);
    });

    if (finalOptions.preserveQuery) {
      const currentQueryParams = new URLSearchParams(location.search);

      currentQueryParams.forEach((value, key) => {
        if (
          !mergedQueryParams.has(key) &&
          !finalOptions.noPreserveKey?.includes(key)
        ) {
          mergedQueryParams.append(key, value);
        }
      });
    }

    const finalQuery = mergedQueryParams.toString();

    navigate(`${basePath}${finalQuery ? `?${finalQuery}` : ""}`);
  };

  return navigateTo;
};

export default useAppNavigate;
